export default "__VITE_ASSET__CjmsMISa__"